const Landing = () => {
    window.location.href = "http://hello.tbd.health/pilot";
}

export default Landing;
